import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3471768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_3 = { class: "complete" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_Header = _resolveComponent("Header")!
  const _component_TopSearches = _resolveComponent("TopSearches")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { skipPath: $setup.skipPath }, {
      center: _withCtx(() => [
        _createVNode(_component_van_search, {
          modelValue: $setup.searchKeyword,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (($setup.searchKeyword) = $event)),
            $setup.updateValue
          ],
          shape: "round",
          "show-action": "",
          "left-icon": "",
          placeholder: "I'm looking for...",
          onSearch: $setup.onSearchValue,
          ref: "refsFocus"
        }, {
          action: _withCtx(() => [
            _createVNode(_component_van_button, {
              round: "",
              type: "primary",
              color: "#f76900",
              class: "search_btns",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSearchValue($setup.searchKeyword)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "onSearch"])
      ]),
      _: 1
    }, 8, ["skipPath"]),
    _createVNode(_component_TopSearches, {
      top_searches: $setup.top_searches,
      onOnSearchValue: $setup.onSearchValue
    }, null, 8, ["top_searches", "onOnSearchValue"]),
    _withDirectives(_createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searvhValueList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: ($event: any) => ($setup.onSearchValue(item.value))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.value), 1),
          _hoisted_5,
          _createVNode(_component_van_icon, { name: "arrow" })
        ], 8, _hoisted_4))
      }), 128))
    ], 512), [
      [_vShow, $setup.searvhValue]
    ])
  ]))
}